document.addEventListener("DOMContentLoaded", function() {
  const stickyBar = document.getElementById("sticky-add-to-cart-bar");
  const stickyBtn = document.getElementById("sticky-add-to-cart-btn");
  
  if (!stickyBar || !stickyBtn) return;

  function initStickyCart() {
    // Find the main product add to cart button.
    const mainAddToCartBtn = document.querySelector('button[name="add"].product-form__submit, button.product-form__submit, .product-form__submit');
    
    if (mainAddToCartBtn) {
      // Show/hide based on scroll
      window.addEventListener("scroll", function() {
        const btnRect = mainAddToCartBtn.getBoundingClientRect();
        // Show sticky bar when the main button is scrolled out of view upwards
        if (btnRect.bottom < 0) {
          stickyBar.classList.add("visible");
        } else {
          stickyBar.classList.remove("visible");
        }
      });

      // Forward click to main button
      stickyBtn.addEventListener("click", function(e) {
        e.preventDefault();
        mainAddToCartBtn.click();
      });

      // Observe the main button for disabled state changes (e.g. variant change to sold out)
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName === "disabled" || mutation.type === "childList") {
            stickyBtn.disabled = mainAddToCartBtn.disabled;
            // update text if possible
            const mainSpan = mainAddToCartBtn.querySelector('span');
            if (mainSpan && stickyBtn) {
              stickyBtn.innerText = mainSpan.innerText;
            } else {
               stickyBtn.innerText = mainAddToCartBtn.innerText;
            }
          }
        });
      });
      
      observer.observe(mainAddToCartBtn, { attributes: true, childList: true, subtree: true });
    }
  }

  // Delay initialization slightly to ensure all third-party apps (like Shiprocket) have initialized the DOM
  setTimeout(initStickyCart, 500);
});
